import React from 'react';
import Banner from '../CommonComponents/Banner';
import HotelList from '../HotelComponents/HotelList';
import GreenHouseInn from "../assets/images/green-house-inn.jpg";
import British from "../assets/images/CA_BritishColumbia_CA_Header.webp";
import EcoLodge from "../assets/images/Eco-Lodge.webp";
import Downtown from "../assets/images/downtown-ottawa.webp";
import SustainableSuites from "../assets/images/The-Sustainable-Suites.jpg";
import Header from '../LayoutComponents/Header';
import Footer from '../LayoutComponents/Footer';
const EcoFriendlyHotels = () => {
  const ecoFriendlyHotels = [
    {
      name: "The Green House Inn",
      image: GreenHouseInn,
      location: "Vancouver, British Columbia",
      overview: "The Green House Inn is a pioneering eco-friendly hotel that combines sustainability with comfort in Vancouver.",
      rooms: "The hotel offers eco-conscious rooms with energy-efficient lighting, water-saving fixtures, and organic bedding. Each room includes free Wi-Fi, flat-screen TVs, and eco-friendly toiletries.",
      dining: "Guests can enjoy a farm-to-table dining experience at the hotel's restaurant, which emphasizes locally sourced and sustainable ingredients.",
      facilities: "The Green House Inn features a fitness center, a garden area, and event spaces. The hotel also offers bike rentals and electric vehicle charging stations.",
      service: "The staff are knowledgeable about sustainability and provide exceptional service, ensuring an eco-friendly and comfortable stay.",
      experience: "The Green House Inn offers a unique blend of comfort and sustainability, perfect for eco-conscious travelers visiting Vancouver."
    },
    {
      name: "Eco Lodge Toronto",
      image: EcoLodge,
      location: "Toronto, Ontario",
      overview: "Eco Lodge Toronto is committed to environmental sustainability while offering comfortable accommodations in the heart of Toronto.",
      rooms: "The hotel features rooms with green design elements, including energy-efficient appliances and recycled materials. Guests can enjoy free Wi-Fi, flat-screen TVs, and organic amenities.",
      dining: "The hotel's restaurant offers organic and locally sourced meals, providing a sustainable dining experience.",
      facilities: "Eco Lodge includes a fitness center, a green rooftop garden, and meeting rooms. The hotel promotes eco-friendly practices and offers bike rentals for guests.",
      service: "The staff are dedicated to providing outstanding service with a focus on sustainability and guest comfort.",
      experience: "Eco Lodge Toronto combines green practices with modern amenities, offering a comfortable and environmentally responsible stay in Toronto."
    },
    {
      name: "The Sustainable Suites",
      image: SustainableSuites,
      location: "Calgary, Alberta",
      overview: "The Sustainable Suites in Calgary offers eco-friendly accommodations with a commitment to sustainability and comfort.",
      rooms: "The hotel's suites feature energy-efficient systems, water-saving fixtures, and sustainable materials. Each suite includes high-speed internet, flat-screen TVs, and eco-friendly amenities.",
      dining: "Guests can enjoy a range of organic and sustainable options at the hotel's restaurant, focusing on locally sourced ingredients.",
      facilities: "The Sustainable Suites features a fitness center, a green garden area, and event spaces. The hotel also provides electric vehicle charging stations and promotes waste reduction practices.",
      service: "The staff provide excellent service with a focus on sustainability and guest satisfaction.",
      experience: "The Sustainable Suites offers a blend of modern luxury and environmental responsibility, ideal for eco-conscious travelers in Calgary."
    },
    {
      name: "Green Stay Hotel",
      image:Downtown,
      location: "Ottawa, Ontario",
      overview: "Green Stay Hotel combines eco-friendly practices with modern comfort in Ottawa.",
      rooms: "The hotel's rooms are designed with sustainable materials and energy-efficient features. Each room includes free Wi-Fi, flat-screen TVs, and eco-friendly toiletries.",
      dining: "The hotel offers a dining experience focused on organic and locally sourced ingredients, promoting sustainability.",
      facilities: "Green Stay Hotel features a fitness center, a green roof garden, and business services. The hotel also offers bike rentals and promotes recycling and waste reduction.",
      service: "The staff are dedicated to providing high-quality service with a commitment to environmental sustainability.",
      experience: "Green Stay Hotel provides a comfortable and eco-friendly stay in Ottawa, perfect for travelers seeking sustainable accommodations."
    },
    {
      name: "Eco Haven Lodge",
      image: British,
      location: "Victoria, British Columbia",
      overview: "Eco Haven Lodge offers an environmentally conscious retreat with modern amenities and a focus on sustainability in Victoria.",
      rooms: "The lodge features eco-friendly rooms with energy-saving systems, recycled materials, and organic bedding. Each room includes free Wi-Fi, flat-screen TVs, and green toiletries.",
      dining: "The lodge's restaurant focuses on sustainable dining with locally sourced and organic ingredients.",
      facilities: "Eco Haven Lodge includes a fitness center, a garden area, and event spaces. The lodge promotes green practices and offers electric vehicle charging stations.",
      service: "The friendly staff provide exceptional service with a focus on sustainability and guest comfort.",
      experience: "Eco Haven Lodge offers a blend of modern amenities and environmental responsibility, making it an ideal choice for eco-conscious travelers in Victoria."
    }
  ];

  return (
    <>
    <Header />
      <Banner 
        title="Stay<span> Green</span>: Top <span>Eco-Friendly</span> Hotels in New Zealand"
        description="Embrace sustainability without compromising on comfort with cloudmingle's recommendations for eco-friendly hotels in New Zealand. Our reviews feature accommodations that prioritize environmental responsibility through innovative practices and green amenities. Whether you're an eco-conscious traveler or simply looking to reduce your carbon footprint, discover hotels that offer a harmonious blend of luxury and sustainability amidst New Zealand’s breathtaking fjords and landscapes."
      />
      <HotelList hotels={ecoFriendlyHotels} />
            <Footer />
      
    </>
  );
};

export default EcoFriendlyHotels;